import { httpClient } from '../httpClient';
import { apiErrorHandler } from './helpers';

export const postDiscount = taxInfo => {
  return httpClient
    .post('/admin/discount', taxInfo)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getAllDiscount = () => {
  return httpClient
    .get('/admin/discount')
    .then(response => response)
    .catch(error => error.response);
};

export const getDiscount = id => {
  return httpClient
    .get(`/admin/discount/${id}`)
    .then(response => response)
    .catch(error => error.response);
};

export const updateDiscount = (id, discountInfo) => {
  return httpClient
    .patch(`/admin/discount/${id}`, discountInfo)
    .then(response => response)
    .catch(error => error.response);
};

export const deleteDiscount = id => {
  console.log(id);
  return httpClient
    .delete(`/admin/discount/${id}`)
    .then(response => response)
    .catch(error => error.response);
};
